export default __webpack_public_path__ + "static/media/plus.8bf9d15f.svg";